/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AssetsDownloadedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Assets Downloaded',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M12 24H4V4h28v11.624a12.045 12.045 0 0 1 2 1.458V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h11a11.975 11.975 0 0 1 .181-2Z"
    />
    <path
      d="M26 16.05A9.95 9.95 0 1 0 35.95 26 9.95 9.95 0 0 0 26 16.05Zm-.17 16.181-5.39-5.364a.5.5 0 0 1 .339-.867H24v-5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V26h3.221a.5.5 0 0 1 .339.867l-5.39 5.364a.25.25 0 0 1-.34 0Z"
    />
  </svg>`;
};
